// extracted by mini-css-extract-plugin
export default {"product_drawer_header":"yu","subtitle":"zu","in_subscription":"Au","items":"Bu","title":"Cu","recommended":"Eu"};
    if(module.hot) {
      // 1721922359783
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  